import { render, staticRenderFns } from "./Withdrawals.vue?vue&type=template&id=2a91bbf1&scoped=true&"
import script from "./Withdrawals.vue?vue&type=script&lang=js&"
export * from "./Withdrawals.vue?vue&type=script&lang=js&"
import style0 from "./Withdrawals.vue?vue&type=style&index=0&id=2a91bbf1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a91bbf1",
  null
  
)

export default component.exports